import { createContext } from 'react';

export const ProviderContext = createContext({});

const ExternalProvider = ({ children, value }) => {
	return <ProviderContext.Provider value={value}>{children}</ProviderContext.Provider>;
};

export default ExternalProvider;
